import api, { setAuth } from './api';

const getAccount = () => api.post('/v1/wallet');

const setToken = async () => {
  await setAuth();
};

export default { getAccount, setToken };
